import { render } from "./notificaciones.vue?vue&type=template&id=59302d13"
import script from "./notificaciones.vue?vue&type=script&lang=js"
export * from "./notificaciones.vue?vue&type=script&lang=js"

import "./notificaciones.vue?vue&type=style&index=0&id=59302d13&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__